import { useEffect, useState } from 'react';

const useMediaQuery = mediaQuery => {
  const [state, setState] = useState(window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(mediaQuery);
    const onChange = () => {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };

    mql.addListener(onChange);
    setState(mql.matches);

    return () => {
      mounted = false;
      mql.removeListener(onChange);
    };
  }, [mediaQuery]);

  return state;
};

export default useMediaQuery;
